import React from 'react'

const Plannings = () => {
  return (
    <div>Plannings</div>
  )
}

export default Plannings